import { NavLink } from "react-router-dom";
import logo from "../../img/logo.svg";

const linkClass = ({ isActive }) => (isActive ? "font-semibold text-primary" : "hover:text-primary");

/**
 * Menu lateral de altura total: logo pequeno no topo, links da área e,
 * no pé, o usuário logado e o "Sair". `links`: [{ to, label, end? }] ou,
 * para outro site, [{ href, label }] (abre em nova aba).
 */
const SideNav = ({ home, links, user, onLogout }) => (
    <nav aria-label="Menu principal" className="sticky top-0 flex h-screen w-32 shrink-0 flex-col border-r border-[#b47c06] px-2 text-sm">
        <NavLink to={home} end className="block">
            <img src={logo} alt="logo" className="w-12 mx-auto my-3" />
        </NavLink>
        <ul className="flex flex-col gap-1 overflow-y-auto text-center">
            {links.map((link) => (
                <li key={link.to ?? link.href}>
                    {link.href ? (
                        <a href={link.href} target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                            {link.label} <span aria-hidden="true">↗</span>
                        </a>
                    ) : (
                        <NavLink to={link.to} end={link.end} className={linkClass}>{link.label}</NavLink>
                    )}
                </li>
            ))}
        </ul>
        <div className="mt-auto border-t border-primary/30 py-2 text-center text-xs">
            <p className="truncate text-laranjinha/80" title={user?.email}>{user?.name}</p>
            <button type="button" onClick={onLogout} className="hover:text-primary">Sair</button>
        </div>
    </nav>
);

export default SideNav;
